import React from "react";

const About = () => {
  return (
    <>
      <div className="shane_tm_section" id="about">
        <div className="shane_tm_about">
          <div className="container">
            <div className="about_inner">
              <div className="left">
                <div
                  className="image"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                >
                  <img src="/img/header/rachel-golden-headshot3.png" alt="rachel golden headshot" />

                  <div
                    className="main"
                    style={{ backgroundImage: "url(img/header/rachel-golden-headshot3.png)" }}
                  ></div>
                </div>
              </div>

              <div className="right">
                <div
                  className="shane_tm_title"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                >
                  <span>About</span>
                  <h3 className="heading">Product, Growth,<br /> & Brand Marketing</h3>
                  <h5 className="heading"> Charlotte, NC</h5>
                </div>
                <div
                  className="text"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                >
                  <p>
                    Full stack marketing professional with over a decade of experience creating
                    high-impact campaigns and crafting real value for businesses in tech. I focus
                    on weaving storytelling into GTM, growth, and user engagement with the ultimate
                    goal of making complex technology more approachable.
                  </p>
                </div>
                <div
                  className="shane_tm_button"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                >
                  <a href="/Rachel-Golden-Resume.pdf" download>
                    <span style={{ fontWeight: "600"}}>Download CV</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
